import * as firebase from 'firebase/app';
import '../firebasesetup';

import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import Vue from 'vue';
import { Client } from '@bugsnag/browser/dist/types/bugsnag-core';

/**
 * Declare process variable
 */
declare var process: {
  env: {
    VUE_APP_VERSION: string,
    NODE_ENV: string,
    VUE_APP_FIREBASE_TARGET: string,
    BASE_URL: string,
  },
};

// In production mode, enable monitoring
let bugsnagClient: Client | null = null;
if (process.env.NODE_ENV === 'production') {
  bugsnagClient = bugsnag({appVersion: process.env.VUE_APP_VERSION, apiKey: 'c314eac7ddd691908bd8e233e22dedf9'});
  bugsnagClient.use(bugsnagVue, Vue);
  bugsnagClient.leaveBreadcrumb('App booting');
}

export default (to, from, next) => {
  let unsubscribe: firebase.Unsubscribe | null = null;
  const initializeAuth = new Promise((resolve, reject) => {
    try {
      // this adds a hook for the initial auth-change event
      unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        resolve(user as object);
      });
    } catch (error) {
      if (bugsnagClient !== null) {
        bugsnagClient.notify(error);
      }
      reject(error);
    }
  });

  initializeAuth.then((user) => {
    // If user is logged in
    if (user != null) {

      // Special case: Instead of homepage forward to loggedIn homepage
      if (to.path === '/') {
        next('/home');
      } else {
        next();
      }

    // If user is not logged in, if homepage everything is fine
    } else if (to.path === '/') {
      next();
    // If any other page is requested, forward to homepage
    } else {
      next('/');
    }

    // Unsubscribe from authstatelistener
    if (unsubscribe !== null) {
      unsubscribe();
    }
  })
  .catch(() => {
    // In case of error, redirect to homepage
    next('/');
  });
};
